<template>
  <div class="pl-3">
    <v-row justify="center" align="center">
      <v-combobox
        label="Load Filters Set"
        dense
        :outlined="outlinedInputs"
        hide-details
        :items="setsList"
        item-value="id"
        item-text="name"
        @change="onSetChange"
        v-model="selectedSet"
        v-if="setsList.length > 0"
      >
        <template v-slot:item="{ item }">
          <div>{{ item.name }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="onDeleteSet(item.id)" class="ml-2">
            <v-icon small color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-combobox>

      <v-tooltip bottom v-if="currentFilters.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            text
            icon
            @click="onShowSaveDialog"
            class="ml-1"
          >
            <v-icon>mdi-content-save-outline</v-icon>
          </v-btn>
        </template>
        <span>Save Current Set of Filters</span>
      </v-tooltip>
    </v-row>
    <basic-dialog
      :show="showDialog"
      @close="showDialog = false"
      max-width="550"
    >
      <template v-slot:title>Save Current Set of Filters</template>
      <v-row>
        <v-col>
          <v-text-field
            label="Set Name"
            v-model="setName"
            :outlined="outlinedInputs"
            hide-details
            :disabled="!saveEnabled"
          ></v-text-field>
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-btn color="primary" @click="saveFilterSet" :disabled="!isValid"
          >Save</v-btn
        >
      </template>
    </basic-dialog>
    <v-row v-if="debug">
      <v-col>
        <code>selectedSet: {{ selectedSet }}</code>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "./BasicDialog.vue";
import { removeGQLTypename } from "../../../helpers";
const CREATE_FILTER_SET = gql`
  mutation createFiltersSet($input: CustomFilterInput) {
    createCustomFilter(input: $input) {
      id
      name
      filters
    }
  }
`;
const UPDATE_FILTER_SET = gql`
  mutation updateFiltersSet($input: CustomFilterInput) {
    updateCustomFilter(input: $input) {
      id
      name
      filters
    }
  }
`;
const SETS_LIST = gql`
  query userCustomFilters($refName: String) {
    customFilters(filter: { refName_eq: $refName }) {
      edges {
        node {
          id
          name
          refName
          filters
        }
      }
    }
  }
`;
const DELETE_FILTER_SET = gql`
  mutation deleteFiltersSet($id: ID!) {
    deleteCustomFilter(id: $id) {
      id
      name
      refName
      filters
    }
  }
`;
export default {
  components: { BasicDialog },
  name: "custom-list-filters",
  props: {
    refName: {
      type: String,
      required: true,
    },
    currentFilters: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      debug: false,
      showDialog: false,
      setName: "",
      selectedSet: "",
    };
  },

  computed: {
    isValid() {
      return this.setName.length > 0;
    },
    saveEnabled() {
      return this.currentFilters.length > 0;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    setsList() {
      return this.customFilters && this.customFilters.edges.length > 0
        ? this.customFilters.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onShowSaveDialog() {
      this.showDialog = true;
      this.setName = this.selectedSet ? this.selectedSet.name : "";
    },
    saveFilterSet() {
      this.showDialog = false;
      const existingSet = this.setsList.find(
        (set) => set.name === this.setName
      );

      //console.log(this.refName, JSON.stringify(this.currentFilters));
      this.$apollo
        .mutate({
          mutation: existingSet ? UPDATE_FILTER_SET : CREATE_FILTER_SET,
          variables: {
            input: {
              id: existingSet ? existingSet.id : undefined,
              name: this.setName,
              refName: this.refName,
              filters: JSON.stringify(this.currentFilters),
            },
          },
          refetchQueries: [
            {
              query: SETS_LIST,
              variables: { refName: this.refName },
            },
          ],
        })
        .then((result) => {
          //console.log(result);
          this.selectedSet = existingSet
            ? { ...result.data.updateCustomFilter }
            : { ...result.data.createCustomFilter };
          //this.$emit("load-filters", JSON.parse(newSet.filters));
        })
        .catch((error) => {
          const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onSetChange(payload) {
      if (payload) {
        const set = this.setsList.find((s) => s.id === payload.id);
        if (set) {
          const filters = JSON.parse(set.filters);
          this.$emit("load-filters", filters);
        }
      }
    },
    onDeleteSet(setId) {
      console.log("onDeleteSet", setId);
      this.$apollo
        .mutate({
          mutation: DELETE_FILTER_SET,
          variables: { id: setId },
          refetchQueries: [
            { query: SETS_LIST, variables: { refName: this.refName } },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Set deleted successfully",
            color: "success",
          });
          this.selectedSet = "";
        })
        .catch((error) => {
          const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },
  apollo: {
    customFilters: {
      query: SETS_LIST,
      variables() {
        return { refName: this.refName };
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/CustomListFilters.vue